import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import AppLayout from '@/layouts/App'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',

  routes: [
    //Inicio
    {
      path: '/',
      component: AppLayout,
      redirect: '/inicio',
      meta: { authRequired: true, hidden: true, breadcrumb: 'Inicio'},
      children: [
        {
          path: '/inicio',
          name: 'Inicio',
          meta: {
            title: 'Inicio',
          },
          component: () => import('./views/dashboard/home'),
        }
      ],
    },

    //Agencias
    {
      path: '/admin/agencias',
      component: AppLayout,
      meta: { authRequired: true, hidden: true, breadcrumb: 'Agencias' },
      children: [
        {
          path: '/',
          name: 'Agencias',
          meta: {
            title: 'Agencias',
          },
          component: () => import('./views/agencies'),
        },
        {
          path: '/admin/agencias/:id/cajas',
          name: 'BoxAgency',
          meta: {
            title: 'Agencia | Cajas',
            breadcrumb: 'Cajas'
          },
          component: () => import('./views/agencies/box'),
        },
        {
          path: '/admin/agencias/:id/ingresos',
          name: 'IncomeAgency',
          meta: {
            title: 'Agencia | Ingresos',
            breadcrumb: 'Ingresos'
          },
          component: () => import('./views/agencies/income'),
        },
        {
          path: '/admin/agencias/:id/salidas',
          name: 'OutputAgency',
          meta: {
            title: 'Agencia | Salidas',
            breadcrumb: 'Salidas'
          },
          component: () => import('./views/agencies/output'),
        },
      ]
    },

    //Cajas
    {
      path: '/almacen/cajas',
      component: AppLayout,
      meta: { authRequired: true, hidden: true, breadcrumb: 'Cajas' },
      children: [
        {
          path: '/',
          name: 'ListBoxes',
          meta: {
            title: 'Cajas',
          },
          component: () => import('./views/boxes'),
        },
        {
          path: '/almacen/cajas/:id/carpetas',
          name: 'ListFolderBox',
          meta: {
            title: 'Carpetas',
            breadcrumb: 'Carpetas'
          },
          component: () => import('./views/boxes/folder')
        },
      ],
    },

    //Ingresos
    {
      path: '/almacen/ingresos',
      component: AppLayout,
      meta: { authRequired: true, hidden: true, breadcrumb: 'Ingresos' },
      children: [
        {
          path: '/',
          name: 'ListIncomes',
          meta: {
            title: 'Ingresos',
          },
          component: () => import('./views/incomes'),
        },
      ],
    },

    //Salidas
    {
      path: '/almacen/salidas',
      component: AppLayout,
      meta: { authRequired: true, hidden: true, breadcrumb: 'Salidas' },
      children: [
        {
          path: '/',
          name: 'ListOutputs',
          meta: {
            title: 'Salidas',
          },
          component: () => import('./views/outputs'),
        },
      ],
    },

    //Digital
    {
      path: '/almacen/digital',
      component: AppLayout,
      meta: { authRequired: true, hidden: true, breadcrumb: 'Digital' },
      children: [
        {
          path: '/',
          name: 'ListDigital',
          meta: {
            title: 'Digital',
          },
          component: () => import('./views/digital'),
        },
      ],
    },

    //Reportes
    {
      path: '/reportes',
      component: AppLayout,
      meta: { authRequired: true, hidden: true, breadcrumb: 'Reportes' },
      children: [
        {
          path: '/',
          name: 'Reports',
          meta: {
            title: 'Reportes',
          },
          component: () => import('./views/reports'),
        },
      ]
    },

    // System Pages
    {
      path: '/system',
      component: AuthLayout,
      redirect: '/system/login',
      children: [
        {
          path: '/system/login',
          meta: {
            title: 'Login',
            redirectIfLogged: true 
          },
          component: () => import('./views/system/login'),
        },
        {
          path: '/system/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/system/404'),
        },
        {
          path: '/system/403',
          meta: {
            title: 'Error 403',
          },
          component: () => import('./views/system/403'),
        },
      ],
    },

    {
      path: '*', redirect: 'system/404', hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.getters.authenticating) {
      next({
        path: '/system/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.redirectIfLogged)) {
    if (store.getters.authenticating) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
